import { Grid, Typography } from '@mui/material';
import clsx from 'clsx';
import * as context from 'api/base';
import { getChannelContentsByKey, getChannelSettingByKey } from '../../routes/generic/Helpers/GenericIndexHelper';
import { useStyles } from '../styles/FooterLayoutAdvancedStyles';

const SECOND_FOOTER_CONTENT_KEYS = [
	'Footer-Second-First-Card-Content',
	'Footer-Second-Second-Card-Content',
	'Footer-Second-Third-Card-Content'
];

const THIRD_FOOTER_CONTENT_KEYS = [
	'Footer-Third-First-Card-Content',
	'Footer-Third-Second-Card-Content',
	'Footer-Third-Third-Card-Content'
];

// Both sections are hidden unless the channel explicitly says otherwise, so an absent setting counts
// as off.
const isSectionEnabled = key => getChannelSettingByKey(key) === 'false';

const hasAnyCardContent = keys => keys.some(key => getChannelContentsByKey(key)?.trim());

// A section needs content as well as its flag. Switched on but empty it is not free: MUI's
// spacing={4} puts 32px of padding-top on each of the three Grid items and only pulls 32px back on
// the container, so where the cards stack (below md) an empty section lays down 64px of blank band
// under the main footer, plus the wrapper's own margin. The caller uses this to decide whether to
// render the wrapper at all, so an empty pair costs nothing rather than 10px.
export const getVisibleAdvancedFooters = () => ({
	second: isSectionEnabled('Footer-Second-Hide') && hasAnyCardContent(SECOND_FOOTER_CONTENT_KEYS),
	third: isSectionEnabled('Footer-Third-Hide') && hasAnyCardContent(THIRD_FOOTER_CONTENT_KEYS)
});

const FooterLayoutAdvanced = () => {
	const themeinfo = context.getSettings();
	const classes = useStyles(themeinfo);
	const footerSecondFirstCardContent = getChannelContentsByKey('Footer-Second-First-Card-Content');
	const footerSecondSecondCardContent = getChannelContentsByKey('Footer-Second-Second-Card-Content');
	const footerSecondThirdCardContent = getChannelContentsByKey('Footer-Second-Third-Card-Content');
	const footerThirdFirstCardContent = getChannelContentsByKey('Footer-Third-First-Card-Content');
	const footerThirdSecondCardContent = getChannelContentsByKey('Footer-Third-Second-Card-Content');
	const footerThirdThirdCardContent = getChannelContentsByKey('Footer-Third-Third-Card-Content');
	const visibleFooters = getVisibleAdvancedFooters();

	return (
		<div>
			{visibleFooters.second && (
				<div style={classes?.secondFooterBgColor}>
					<div className="container">
						<Grid container spacing={4}>
							<Grid item xs={12} md={4}>
								<Typography paragraph={false} variant="body1">
									{footerSecondFirstCardContent && (
										<div
											dangerouslySetInnerHTML={{
												__html: footerSecondFirstCardContent
											}}
										/>
									)}
								</Typography>
							</Grid>
							<Grid item xs={12} md={4}>
								{footerSecondSecondCardContent && (
									<div
										dangerouslySetInnerHTML={{
											__html: footerSecondSecondCardContent
										}}
									/>
								)}
							</Grid>
							<Grid item xs={12} md={4}>
								{footerSecondThirdCardContent && (
									<div
										dangerouslySetInnerHTML={{
											__html: footerSecondThirdCardContent
										}}
									/>
								)}
							</Grid>
						</Grid>
					</div>
				</div>
			)}
			{visibleFooters.third && (
				<div style={classes?.thirdFooterBgColor} className="mt-10">
					<div className="container">
						<Grid container spacing={4}>
							<Grid item xs={12} md={4}>
								{footerThirdFirstCardContent && (
									<div
										dangerouslySetInnerHTML={{
											__html: footerThirdFirstCardContent
										}}
									/>
								)}
							</Grid>
							<Grid item xs={12} md={4}>
								{footerThirdSecondCardContent && (
									<div
										dangerouslySetInnerHTML={{
											__html: footerThirdSecondCardContent
										}}
									/>
								)}
							</Grid>
							<Grid item xs={12} md={4}>
								{footerThirdThirdCardContent && (
									<div
										dangerouslySetInnerHTML={{
											__html: footerThirdThirdCardContent
										}}
									/>
								)}
							</Grid>
						</Grid>
					</div>
				</div>
			)}
		</div>
	);
};

export default FooterLayoutAdvanced;
